import { css } from '@emotion/css';

export const bankAccountInputCx = css`
  .bank-account-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: nowrap;

    .bank-account-input {
      flex: 1;
      margin-right: 1rem;
    }

    .bank-account-verify-btn {
      gap: 0.25rem;
      display: flex;
      padding: 0.675rem;
      min-width: 7.5rem;
      align-items: center;
      justify-content: center;
      background-color: white;
    }
  }
`;

export const bankInputWarning = css`
  background: var(--colors-orange-10);
  border-radius: 8px;
  padding: 8px;
  margin-top: 8px;

  & > div {
    display: flex;
    align-items: center;
    gap: 4px;
  }
`;
